import React from "react";
import clsx from 'clsx';
import { SvgIcon } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  root: {
    width: 74,
    height: 88,
    fill: "transparent"
  }
});

class IcHouse extends React.Component {

  render() {
    const { classes, className } = this.props;

    return <SvgIcon className = { clsx(classes.root, className) }
                    viewBox = { "0 0 74 88" } >
      <path d="M9.125 14.375H46.5V73.625H9.125V14.375Z" stroke="#004876" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M21.7621 25.5631H18.3049V31.5016H21.7621V25.5631ZM16 23.5836V33.4811H24.067V23.5836H16Z" fill="#004876"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M21.7626 40.4091H18.3053V46.3476H21.7626V40.4091ZM16.0005 38.4296V48.3271H24.0675V38.4296H16.0005Z" fill="#004876"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M21.7626 55.2553H18.3053V61.1938H21.7626V55.2553ZM16.0005 53.2758V63.1733H24.0675V53.2758H16.0005Z" fill="#004876"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M37.3202 25.5628H33.863V31.5013H37.3202V25.5628ZM31.5581 23.5833V33.4808H39.6251V23.5833H31.5581Z" fill="#004876"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M37.3202 40.4092H33.863V46.3477H37.3202V40.4092ZM31.5581 38.4297V48.3272H39.6251V38.4297H31.5581Z" fill="#004876"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M37.3202 55.2553H33.863V61.1938H37.3202V55.2553ZM31.5581 53.2758V63.1733H39.6251V53.2758H31.5581Z" fill="#004876"/>
      <path d="M47.5 24.75H61.9375V73.3125H47.5" stroke="#004876" strokeWidth="2"/>
    </SvgIcon>
  }
}

export default withStyles(styles)(IcHouse);
